import { c as _c } from "react/compiler-runtime";
export default function DocumentListIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M63 27v42H33V27h30zm0-2H33a2 2 0 0 0-2 2v42a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V27a2 2 0 0 0-2-2zm-4 9H44v2h15v-2zm0 7H44v2h15v-2zm0 7H44v2h15v-2zm0 7H44v2h15v-2zM41 33h-4v4h4v-4zm0 7h-4v4h4v-4zm0 7h-4v4h4v-4zm0 7h-4v4h4v-4z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}